module.exports = __webpack_public_path__ + "img/en_yes.f82a229c.png";